export default "__VITE_ASSET__13KnS4qX__"